import { useState, useEffect } from 'react'

export const useSession = () => {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    const userData = localStorage.getItem('user')
    
    if (token && userData) {
      try {
        const user = JSON.parse(userData)
        setSession({ token, user })
      } catch (error) {
        console.error('Error parsing user data:', error)
        clearSession()
      }
    }
    setLoading(false)
  }, [])

  const createSession = (token, user) => {
    localStorage.setItem('token', token)
    localStorage.setItem('user', JSON.stringify(user))
    setSession({ token, user })
  }

  const clearSession = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    setSession(null)
  }

  const updateUser = (user) => {
    if (session) {
      const updatedSession = { ...session, user }
      localStorage.setItem('user', JSON.stringify(user))
      setSession(updatedSession)
    }
  }

  return {
    session,
    loading,
    isAuthenticated: !!session,
    user: session?.user || null,
    token: session?.token || null,
    createSession,
    clearSession,
    updateUser,
  }
}